
export default {
  productData: {
    serialNumber: 'DA-HMUF-001',
    name: 'Holzbalkendecken mit Unterdecken an Federschienen | Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 6 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 40',
          value: 'm-40'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 45 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '≥ 30',
          value: 'scsb-30'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '27',
          value: 'f-27'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '401,5', value: 401.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '34 (12)',
        value: 34
      },
      soundReductionIndex: { // Rw
        output: '≥ 70',
        value: 70
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,26',
        value: 0.26
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '214,6 [kg/m²]'
      }
    }
  },
  image: 'da-hmuf-001.png',
  pdf: 'Holzbalkendecken-mit-Unterdecken-an-Federschiene-Aufbau-1-DA-HMUF-001-Rev04.pdf'
}
